import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CardaMacakLanding from "./pages/CardaMacakLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CardaMacakLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
